import { useState } from 'react';
import Button from '../shared/Button';
import TimeBlockEditor from './TimeBlockEditor';
import { getPriorityDisplay } from '../../utils/formatters';
import { formatTime } from '../../utils/timeHelpers';
import useTripStore from '../../context/TripStore';

const TimeBlockList = () => {
  const { places } = useTripStore();
  const [editingPlace, setEditingPlace] = useState(null);

  const lockedPlaces = places.filter(p => p.lockedTime);
  const unlockedPlaces = places.filter(p => !p.lockedTime);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xs font-light uppercase tracking-wide text-gray-600 mb-3">Time-Locked Items</h2>
        {lockedPlaces.length > 0 ? (
          <div className="space-y-2">
            {lockedPlaces.map((place) => {
              const priorityDisplay = getPriorityDisplay(place.priority);
              return (
                <div
                  key={place.id}
                  className="bg-white border border-gray-300 p-3"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-0.5">
                        <span className="text-sm font-light">{place.name}</span>
                        <span className={priorityDisplay.color}>
                          {priorityDisplay.emoji}
                        </span>
                      </div>
                      <p className="text-xs font-light text-gray-500">
                        🔒 Locked at {formatTime(place.lockedTime)}
                      </p>
                    </div>
                    <Button
                      variant="secondary"
                      onClick={() => setEditingPlace(place)}
                      className="text-xs py-0.5 px-2"
                    >
                      Edit
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-xs font-light text-gray-400 text-center py-4 border border-dashed border-gray-300">
            No time-locked items yet. Lock times for reservations or timed entries.
          </p>
        )}
      </div>

      <div>
        <h2 className="text-xs font-light uppercase tracking-wide text-gray-600 mb-3">All Places</h2>
        {unlockedPlaces.length > 0 ? (
          <div className="space-y-2">
            {unlockedPlaces.map((place) => {
              const priorityDisplay = getPriorityDisplay(place.priority);
              return (
                <div
                  key={place.id}
                  className="bg-white border border-gray-200 p-3"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-light">{place.name}</span>
                      <span className={priorityDisplay.color}>
                        {priorityDisplay.emoji}
                      </span>
                    </div>
                    <Button
                      variant="secondary"
                      onClick={() => setEditingPlace(place)}
                      className="text-xs py-0.5 px-2"
                    >
                      Lock Time
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-xs font-light text-gray-400 text-center py-4 border border-dashed border-gray-300">
            All places are time-locked.
          </p>
        )}
      </div>

      {editingPlace && (
        <TimeBlockEditor
          place={editingPlace}
          isOpen={!!editingPlace}
          onClose={() => setEditingPlace(null)}
        />
      )}
    </div>
  );
};

export default TimeBlockList;

